module.exports = __webpack_public_path__ + "img/level-up.fb763ad2.svg";